module.exports = __webpack_public_path__ + "static/media/arbutus-illustrated-map.3e62d778.png";